import { Component, Input, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { PlyrComponent } from "ngx-plyr";
import { NgxSpinnerService } from "ngx-spinner";
import { GlobalService } from "src/app/services/global.service";
import * as SecureLS from "secure-ls";
import { ActivatedRoute } from "@angular/router";
import CryptoJS from "crypto-js";
import { StorageService } from "../../services/storage.service";
import { AppLogo1 } from "src/app/app.config";

@Component({
  selector: "app-playvideo",
  templateUrl: "./playvideo.component.html",
  styleUrls: ["./playvideo.component.css"],
})
export class PlayvideoComponent implements OnInit {
  @ViewChild(PlyrComponent) plyr: PlyrComponent;
  @Input() bookmarkTopicList: any[];
  private ls = new SecureLS({ encodingType: "aes" });
  appLogo = AppLogo1;
  videosrc: any;
  player: Plyr;
  play_point_cut: any = [];
  user_id: any;
  preffessorName: string;
  subjectName: string;
  classroom_details: any;
  date: string;
  videoTitle: any;
  controlsList = "";
  isHLS = null;
  comments = [];
  currentTime = null;
  initPageNumber = 1;
  showBookmarkList = true;
  mediaPlayerEvent: any;
  transcriptionList: any;
  isTopicAvailable = 0;
  transcriptionTextAvailable = "";
  count: number;

  constructor(
    private storageService: StorageService,
    public globalService: GlobalService,
    public router: ActivatedRoute,
    private spinner: NgxSpinnerService
  ) {}

  async ngOnInit() {
    this.preffessorName = this.ls.get("preffessorName");
    this.subjectName = this.ls.get("subjectName");
    const decrypt = (data) => {
      return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    };
    this.getBookmarkTopics();
    this.getTranscriptionText();
    if (this.router.snapshot.queryParams.isHls) {
      this.isHLS =
        decrypt(this.router.snapshot.queryParams.isHls) === "ZERO" ? 0 : 1;
    }
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      id: this.router.snapshot.queryParams.key,
      resolution_type: "high",
    };
    if (this.isHLS == 0) {
      this.spinner.show();
      let video_url: any = await this.globalService.get(
        "classVideoDetail/get/video-url",
        filter
      );

      if (video_url["status"] == 200) {
        this.videosrc =
          video_url["content"].url +
          "?" +
          "token=" +
          video_url["content"].token +
          "&resolution_type=high&request_type=web";

        this.preffessorName = `${video_url.content.video_size_details.professor_details.first_name} ${video_url.content.video_size_details.professor_details.last_name}`;
        this.subjectName = `${video_url.content.video_size_details.subject_details.name}`;
        this.classroom_details = `${video_url.content.video_size_details.classroom_details.name}`;
        this.videoTitle = video_url.content.video_size_details.video_title
          ? video_url.content.video_size_details.video_title
          : "No Title";
        this.date = `${video_url.content.video_size_details.start_date} ${video_url.content.video_size_details.start_time} UTC`;
        this.filter_list();
      }

      this.user_id = this.ls.get("createdBy");
     
    }
    this.updateVideoLog();
    setInterval(() => {
      this.updateVideoLog();
    }, 30000);
  }

  async getTranscriptionText() {
    //this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
    };

    let transcriptionText = await this.globalService.get("classVideoDetail/get-video-transcription",filter, true);
    if (transcriptionText["status"] == 200) {
      this.transcriptionTextAvailable = transcriptionText["content"]["video_transcription"];
      //this.spinner.hide();
    } else {
      this.transcriptionTextAvailable = "";
      //this.spinner.hide();
    }
  }

  async getBookmarkTopics() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      role_id: this.storageService.getRole(),
    };


    let bookmarkTopic = await this.globalService.get("bookmark/list", filter, true);
    if (bookmarkTopic["status"] == 200) {
      this.bookmarkTopicList = bookmarkTopic["content"];
      this.count=this.bookmarkTopicList.length;
      this.spinner.hide();
    } else {
      this.spinner.hide();
    }
  }

  async ngAfterViewInit() {
    const decrypt = (data) => {
      return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    };
    if (this.router.snapshot.queryParams.isHls) {
      this.isHLS =
        decrypt(this.router.snapshot.queryParams.isHls) === "ZERO" ? 0 : 1;
    }
    if (this.isHLS == 1) {
      let filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        video_id: this.router.snapshot.queryParams.key,
        resolution_type: "high",
      };
      let videourl: any = await this.globalService.get(
        "classVideoDetail/get/stream/video/details",
        filter
      );

      if (videourl["status"] == 200) {
        this.videosrc = `/live/nfs-share${videourl["content"].local_file_path}${videourl["content"].high_file_name}`;
        this.preffessorName = `${videourl.content.professor_details.first_name} ${videourl.content.professor_details.last_name}`;
        this.subjectName = `${videourl.content.subject_details.name}`;
        this.classroom_details = `${videourl.content.classroom_details.name}`;
        this.videoTitle = videourl.content.video_title
          ? videourl.content.video_title
          : "No Title";
        this.date = `${videourl.content.start_date} ${videourl.content.start_time} UTC`;

        this.filter_list();
      }
    }
  }

  onListClick(list): void {
    this.transcriptionList = list;
    this.mediaPlayerEvent.seekTime(Number(list.start), false);
    this.mediaPlayerEvent.play();
  }

  async updateVideoLog() {
    let inputDate: any;
    // To enable download option for admin only
    if (this.router.queryParams["value"].loginType == "impersonate") {
      this.controlsList = "nodownload";
    } else {
      if (
        this.storageService.getRole() == 2 ||
        this.storageService.getRole() == 3
      ) {
        this.controlsList = "";
      } else {
        this.controlsList = "nodownload";
      }
    }

    if (
      this.storageService.getRole() == 4 ||
      this.storageService.getRole() == 5
    ) {
      inputDate = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        video_details_id: this.router.snapshot.queryParams.key,
        video_type: 2,
      };
      let video_log = await this.globalService.create(
        "videolog/student/video/log",
        inputDate
      );
    }
    
  }

  onPlayerReady(event) {
    this.mediaPlayerEvent = event;
    const role = this.storageService.getRole();
    event
      .getDefaultMedia()
      .subscriptions.loadedMetadata.subscribe(($event) => {});
    event.getDefaultMedia().subscriptions.timeUpdate.subscribe(($event) => {
      if (role != 1 && role != 2 && role != 3) {
        this.playing(event);
      }
      if (Number(this.transcriptionList?.end) == event.currentTime) {
        event.pause();
      }
      this.currentTime = this.secondsToHms($event.target.currentTime);
    });
  }
  seekForward() {
    if (this.mediaPlayerEvent) {
      this.mediaPlayerEvent.currentTime += 10;  // Seek forward by 10 seconds
    }
  }
   
  seekBackward() {
    if (this.mediaPlayerEvent) {
      this.mediaPlayerEvent.currentTime -= 10;  // Seek backward by 10 seconds
    }
  } 

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d % 3600) / 60);
    var s = Math.floor((d % 3600) % 60);
    return (
      (h < 10 ? "0" : "") +
      h +
      ":" +
      (m < 10 ? "0" : "") +
      m +
      ":" +
      (s < 10 ? "0" : "") +
      s
    );
  }

  filter_list() {
    let inputData = {
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      user_id: this.ls.get("createdBy"),
    };

    this.globalService
      .get("video/filter/list/filter", inputData,true)
      .then((filter_list) => {
        if (filter_list["status"] === 200) {
          this.play_point_cut = filter_list["content"];
        }
      });
  }

  async playing(event) {
    for await (var duration_point of this.play_point_cut) {
      // Array of filter points
      if (
        event.currentTime >= duration_point.filter_start &&
        event.currentTime < duration_point.filter_end
      ) {
        let skip_point =
          parseFloat(duration_point.filter_end) -
          parseFloat(duration_point.filter_start);
        event.seekTime(skip_point, false);
        event.getDefaultMedia().currentTime = duration_point.filter_end;
        event.play();
      }
    }
  }
}
